// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_nRZ","cls2":"TranslationModal-cls2_-Rz TranslationModal-cls1_nRZ","button":"TranslationModal-button_2bx"};